module.exports = __webpack_public_path__ + "blueBackground-1YSNJvh.png";